const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    updateNotice: 'cart.updateNotice',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render'
  },
  product: {
    updateVariant: 'product.update_variant',
    updateVariantPDP: 'product.update_variant_pdp'
  },
  wishlist: {
    global: 'wishlist.global',
    list: 'wishlist.list',
    change: 'wishlist.change'
  },
  notice: {
    global: 'notice.global'
  },
  modal: {
    show: 'modal.show'
  },
  personaliseModal: {
    show: 'personaliseModal.show'
  }
}

class GlobalEmitter {
  emit(name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })

    document.dispatchEvent(event)
  }

  on(name, callback) {
    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off(name, callback) {
    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export {
  emitterProps,
  globalEmitter
}
